import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function SSOPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { ssoLogin } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const ssoToken = searchParams.get('sso_token');

    if (!ssoToken) {
      navigate('/login', { replace: true });
      return;
    }

    ssoLogin(ssoToken)
      .then(() => navigate('/dashboard', { replace: true }))
      .catch(() => setError('No se pudo autenticar. El enlace puede haber expirado.'));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center space-y-4">
          <p className="text-destructive">{error}</p>
          <a href="/login" className="text-primary underline text-sm">Ir al login</a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-3">
        <div className="animate-spin w-8 h-8 border-2 border-primary border-t-transparent rounded-full mx-auto" />
        <p className="text-muted-foreground text-sm">Iniciando sesión...</p>
      </div>
    </div>
  );
}
